import { render, staticRenderFns } from "./brand-manual-section.vue?vue&type=template&id=5f38cce8&scoped=true&"
import script from "./brand-manual-section.vue?vue&type=script&lang=ts&"
export * from "./brand-manual-section.vue?vue&type=script&lang=ts&"
import style0 from "./brand-manual-section.vue?vue&type=style&index=0&id=5f38cce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f38cce8",
  null
  
)

export default component.exports